import type { Types } from '../types';
import type { OutTypes } from './schedules';
import { getVertexId } from '../util';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { BaseOptions } from '../../common/types';
import type { TeacherVertex } from '../interfaces/vertices/teachers';

export default (
  teachers: Types.Mixed.Teacher[],
  options:  BaseOptions
): OutTypes.teacher[] => {
  return teachers
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<TeacherVertex> = {
        rootInterval:       x.rootInterval ? getVertexId(x.rootInterval, options) : undefined,
        person:             x.person       ? getVertexId(x.person,       options) : undefined,
        exceptions:         x.exceptions        ?.map(x => getVertexId(x, options)),
        lockedTimes:        x.lockedTimes       ?.map(x => getVertexId(x, options)),
        lunch:              x.lunch             ?.map(x => getVertexId(x, options)),
        complementaryTimes: x.complementaryTimes?.map(x => getVertexId(x, options)),
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<TeacherVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
};
